import React from 'react';
import { Zap, Target, MessageCircle, ArrowDown, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
const scrollToFinalCta = (e: React.MouseEvent) => {
  e.preventDefault();
  document.getElementById('final-cta')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};
export function MechanismSection() {
  return <section className="py-24 px-4 bg-[#0f1b2d] text-[#f5f0e8] overflow-hidden" data-id="element-129">
      <div className="max-w-5xl mx-auto" data-id="element-130">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-131">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-black mb-6" data-id="element-132">
            El mecanismo: Mapa 3×3
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-[#f5f0e8]/80" data-id="element-133">
            Aquí no "buscas tu pasión". Aquí creas una combinación inevitable:
          </motion.p>
        </div>

        {/* 3x3 Grid Visual */}
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-134">
          {[{
          icon: Zap,
          title: '1 Habilidad útil',
          sub: '(nivel normal)'
        }, {
          icon: Target,
          title: '1 Problema real',
          sub: '(la gente paga por quitarlo)'
        }, {
          icon: MessageCircle,
          title: '1 Canal simple',
          sub: '(WhatsApp)'
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="bg-[#f5f0e8]/5 border border-[#f5f0e8]/10 p-8 rounded-2xl flex flex-col items-center text-center hover:bg-[#f5f0e8]/10 transition-colors" data-id="element-135">
              <div className="bg-[#25D366]/20 p-4 rounded-full mb-6" data-id="element-136">
                <item.icon className="w-8 h-8 text-[#25D366]" data-id="element-137" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-138">{item.title}</h3>
              <p className="text-[#f5f0e8]/60" data-id="element-139">{item.sub}</p>
            </motion.div>)}
        </div>

        {/* Arrow Down */}
        <motion.div initial={{
        opacity: 0,
        height: 0
      }} whileInView={{
        opacity: 1,
        height: 'auto'
      }} viewport={{
        once: true
      }} className="flex justify-center mb-12" data-id="element-140">
          <ArrowDown className="w-10 h-10 text-[#25D366] animate-bounce" data-id="element-141" />
        </motion.div>

        {/* The Resulting System */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#f5f0e8] text-[#0f1b2d] rounded-3xl p-8 md:p-12 mb-20 shadow-2xl" data-id="element-142">
          <h3 className="text-2xl font-bold text-center mb-10" data-id="element-143">
            Y lo conviertes en:
          </h3>
          <div className="grid md:grid-cols-3 gap-8 text-center" data-id="element-144">
            <div data-id="element-145">
              <div className="font-black text-xl mb-2" data-id="element-146">Oferta 1-página</div>
              <div className="text-sm text-gray-600" data-id="element-147">
                lo entienden en 10 segundos
              </div>
            </div>
            <div className="border-t md:border-t-0 md:border-l border-gray-200 pt-6 md:pt-0" data-id="element-148">
              <div className="font-black text-xl mb-2" data-id="element-149">Mensajes listos</div>
              <div className="text-sm text-gray-600" data-id="element-150">
                no improvisas ni te justificas
              </div>
            </div>
            <div className="border-t md:border-t-0 md:border-l border-gray-200 pt-6 md:pt-0" data-id="element-151">
              <div className="font-black text-xl mb-2" data-id="element-152">
                Plantillas de entrega
              </div>
              <div className="text-sm text-gray-600" data-id="element-153">
                terminas en 90 minutos
              </div>
            </div>
          </div>
        </motion.div>

        {/* WhatsApp Chat Simulation */}
        <div className="max-w-md mx-auto bg-[#e5ddd5] rounded-3xl overflow-hidden shadow-2xl border-4 border-[#0f1b2d]" data-id="element-154">
          <div className="bg-[#075e54] p-4 flex items-center gap-3 text-white shadow-md" data-id="element-155">
            <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-bold" data-id="element-156">
              C
            </div>
            <div data-id="element-157">
              <div className="font-bold text-sm" data-id="element-158">Cliente Potencial</div>
              <div className="text-xs opacity-80" data-id="element-159">en línea</div>
            </div>
          </div>

          <div className="p-4 space-y-4 bg-[url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png')] bg-opacity-10" data-id="element-160">
            {/* Message 1 (Sent) */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="flex justify-end" data-id="element-161">
              <div className="bg-[#dcf8c6] text-black p-3 rounded-lg rounded-tr-none shadow-sm max-w-[85%] text-sm relative" data-id="element-162">
                <p data-id="element-163">
                  Hola Carlos, he visto que andáis liados con las presentaciones
                  de fin de mes.
                </p>
                <div className="text-[10px] text-gray-500 text-right mt-1 flex justify-end items-center gap-1" data-id="element-164">
                  10:30 <span className="text-[#34b7f1]" data-id="element-165">✓✓</span>
                </div>
              </div>
            </motion.div>

            {/* Message 2 (Sent) */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="flex justify-end" data-id="element-166">
              <div className="bg-[#dcf8c6] text-black p-3 rounded-lg rounded-tr-none shadow-sm max-w-[85%] text-sm relative" data-id="element-167">
                <p data-id="element-168">
                  Tengo un sistema para dejarlas listas en 24h sin que tengáis
                  que tocar el PowerPoint. ¿Te paso info en una imagen?
                </p>
                <div className="text-[10px] text-gray-500 text-right mt-1 flex justify-end items-center gap-1" data-id="element-169">
                  10:31 <span className="text-[#34b7f1]" data-id="element-170">✓✓</span>
                </div>
              </div>
            </motion.div>

            {/* Message 3 (Received) */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.8
          }} className="flex justify-start" data-id="element-171">
              <div className="bg-white text-black p-3 rounded-lg rounded-tl-none shadow-sm max-w-[85%] text-sm relative" data-id="element-172">
                <p data-id="element-173">
                  Ostras, pues sí. Justo estamos atascados con eso. Pásame a
                  ver.
                </p>
                <div className="text-[10px] text-gray-500 text-right mt-1" data-id="element-174">
                  10:45
                </div>
              </div>
            </motion.div>
          </div>

          <div className="bg-[#f0f0f0] p-3 flex items-center gap-2" data-id="element-175">
            <div className="flex-1 bg-white rounded-full h-9 px-4 text-sm text-gray-400 flex items-center" data-id="element-176">
              Escribe un mensaje
            </div>
            <div className="w-10 h-10 bg-[#00897b] rounded-full flex items-center justify-center text-white" data-id="element-177">
              <MessageCircle className="w-5 h-5" data-id="element-178" />
            </div>
          </div>
        </div>

        {/* CTA after mechanism section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center gap-2 mt-16" data-id="element-179">
          <a href="#final-cta" onClick={scrollToFinalCta} className="group inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-[#0f1b2d] font-bold text-lg py-4 px-10 rounded-xl shadow-[0_0_30px_rgba(37,211,102,0.3)] hover:shadow-[0_0_50px_rgba(37,211,102,0.5)] transition-all duration-300 transform hover:scale-105" data-id="element-180">
            Quiero el sistema completo
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-181" />
          </a>
          <span className="text-[#f5f0e8]/40 text-sm font-medium flex items-center gap-2" data-id="element-182">
            <span className="line-through opacity-60" data-id="element-183">29€</span>
            <span className="bg-red-500/90 text-white text-xs font-bold px-2 py-0.5 rounded" data-id="element-184">
              -78%
            </span>
            <span className="text-[#25D366] font-bold" data-id="element-185">6,36€</span>
          </span>
        </motion.div>
      </div>
    </section>;
}